import _ from "lodash";
import { getMemoizedFunction } from "Utils";
import { tabFiltersConfig } from "../../../modules/Config";

const getApplicableFiltersInfo = ({ moduleFacets, activeTab }) => {
  const entityTypeInfo = tabFiltersConfig[activeTab].entityTypeInfo;

  const filtersInfo = _.map(moduleFacets, moduleFace => {
    const { entityType, levels, attributes } = moduleFace;
    const { filterLocale, tabDisplayOrder, isCheckList } = entityTypeInfo[
      entityType
    ];

    return {
      filter: entityType,
      key: entityType + " " + activeTab, //here activeTab is added to make filters unique across different tabs
      levels,
      attributes,
      label: filterLocale,
      isCheckList,
      order: tabDisplayOrder,
    };
  });

  return _.sortBy(filtersInfo, ({ order }) => order);
};

export const getApplicableFiltersInfoMemoized = getMemoizedFunction(
  getApplicableFiltersInfo
);

/**This util will update values such that if there are values having same labels,
 * then out of those values only one will remain and rest are discarded.
 */
export const getUniqueSelectedValues = ({ values, options }) => {
  const labels = _.reduce(
    options,
    (result, option) => {
      const { label, value } = option;
      const isOptionSelected = _.includes(values, value);
      if (isOptionSelected) {
        return [...result, label];
      }
      return result;
    },
    []
  );

  const uniqLabels = _.uniq(labels);

  const uniqValues = [];

  _.forEach(uniqLabels, label => {
    const option = _.find(options, ["label", label]);
    if (!_.isEmpty(option)) {
      uniqValues.push(option.value);
    }
  });

  return uniqValues;
};

const findLabel = ({ value, options, t }) => {
  const { label = "" } = _.find(options, ["value", value]) ?? {};
  return label === "" ? t("common:none") : label;
};

export const findLabelMemoized = getMemoizedFunction(findLabel);
